import React from "react";
import { X } from "lucide-react";
import DynamicCTA from "./DynamicCTA";

interface CTAPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  cta: any;
}

export default function CTAPreviewModal({
  isOpen,
  onClose,
  cta,
}: CTAPreviewModalProps) {
  if (!isOpen || !cta) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">CTA Preview</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6">
          <DynamicCTA type={cta.type} />
        </div>
      </div>
    </div>
  );
}
